import React, { memo } from 'react';
import { useField } from 'formik';
import HBAddressStateField from './HBAddressStateField';
import type { HBAddressStateFieldProps } from './HBAddressStateField';
import { useFormInputValidationProps } from '../HBFormFields/useFormFieldProps';

export type HBFormAddressStateFieldProps = Omit<
    HBAddressStateFieldProps,
    'value' | 'onChange' | 'onBlur'
> & {
    /** Called after Formik commits the change. Use for side-effects (e.g. clearing the state field after country change) rather than reading Formik's value directly. */
    onChangeCallback?: (value: string) => void;
    /** Called after Formik processes blur. */
    onBlurCallback?: () => void;
};

const HBFormAddressStateField = ({
    onChangeCallback,
    onBlurCallback,
    required,
    ...props
}: HBFormAddressStateFieldProps) => {
    const [{ value, onBlur }, { error }, { setValue }] = useField(props.id);
    const validationProps = useFormInputValidationProps(props.id);

    return (
        <HBAddressStateField
            {...props}
            required={required ?? validationProps?.required}
            value={(value as string) ?? ''}
            onChange={(v: string) => {
                setValue(v);
                onChangeCallback?.(v);
            }}
            onBlur={() => {
                onBlur(undefined);
                onBlurCallback?.();
            }}
            error={!!error}
            errorMessage={error}
        />
    );
};

export default memo(HBFormAddressStateField);
